import { render, staticRenderFns } from "./splitpane.vue?vue&type=template&id=966b68ea&"
import script from "./splitpane.vue?vue&type=script&lang=js&"
export * from "./splitpane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "splitpane.vue"
export default component.exports